module.exports = __webpack_public_path__ + "static/media/(000094).301afcb1.jpg";